// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2VuyG","top":"styles_top__QLLuW"};